module.exports = __webpack_public_path__ + "img/hdbm-right.4ed05c7f.png";